import qs from 'qs';
import { POPUP_ROUTES } from 'const/router';
import { pathOr } from 'ramda';
import { matchPath } from 'react-router';

export const isCurrentLocation = (history, location) => {
  return history.location.pathname === location;
};

export const parseQueryParams = (searchString, options = {}) => qs.parse(searchString, options);

export const extractPopupPathFromUrlToSearchParam = (pathname, search) => {
  const popupPathInRoute = pathname.split('/').filter(e => POPUP_ROUTES.includes(e))[0];

  const oldSearchParams = qs.parse(search, { ignoreQueryPrefix: true });
  const newSearchParams = {
    popup: popupPathInRoute,
    ...oldSearchParams,
  };
  return qs.stringify(newSearchParams);
};

export const isMatchedPath = path => requiredPath => {
  const match = matchPath(path, { path: requiredPath });

  return pathOr(false, ['isExact'], match);
};



// WEBPACK FOOTER //
// ./src/utils/location.js